import type { ApiJobId } from '#/api/types/ApiTypedId';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

import type { ApiJob } from './types/ApiJob';
import type { ApiUnpublishedJob } from './types/ApiUnpublishedJob';

type ApiResponse = {
  data: ApiJob | ApiUnpublishedJob;
};

function mapResponse(response: ApiResponse): ApiJob | ApiUnpublishedJob {
  return response.data;
}

const endpoint = new FetchEndpoint({
  urlFactory: (jobId: ApiJobId) => `/data/website/jobs/${jobId}`,
  mapResponse,
});

// Exports

export const listingApiIsomorphicFetchJob = endpoint.createIsomorphicFetchFn();
